// Noodl SDK - webpack handles this require properly
const Noodl = require('@noodl/noodl-sdk');
const React = require('react');
import { CustomToggle } from '@shared/components/CustomToggle/CustomToggle';

export const CustomToggleNode = Noodl.defineReactNode({
  name: 'Prodikt Custom Toggle',
  displayName: 'Custom Toggle',
  category: 'Prodikt Components',
  
  getReactComponent() {
    return CustomToggle;
  },

  inputProps: {
    // Basic properties
    label: {
      type: 'string',
      displayName: 'Label',
      group: 'General'
    },
    isSelected: {
      type: 'boolean',
      displayName: 'Selected',
      default: false,
      group: 'Data'
    },
    isDisabled: {
      type: 'boolean',
      displayName: 'Disabled',
      default: false,
      group: 'General'
    },
    size: {
      type: {
        name: 'enum',
        enums: [
          { label: 'Small', value: 'small' },
          { label: 'Medium', value: 'medium' },
          { label: 'Large', value: 'large' }
        ]
      },
      displayName: 'Size',
      default: 'medium',
      group: 'General'
    },

    // Styling
    className: {
      type: 'string',
      displayName: 'CSS Class',
      group: 'Style'
    }
  },

  outputProps: {
    onChange: {
      type: 'signal',
      displayName: 'Changed'
    },
    isSelected: {
      type: 'boolean',
      displayName: 'Is Selected'
    },
    currentValue: {
      type: 'boolean',
      displayName: 'Current Value'
    }
  },

  changed: {
    isSelected: function(value) {
      this._outputIsSelected = value || false;
      if (this.outputPropValues) {
        this.outputPropValues.currentValue = value || false;
      }
      this.flagOutputDirty('currentValue');
    }
  },

  update: function() {
    // Sync output if props.isSelected has changed (handles initial connected values)
    const currentValue = this.props.isSelected !== undefined ? this.props.isSelected : false;
    if (this._outputIsSelected !== currentValue) {
      this._outputIsSelected = currentValue;
      if (this.outputPropValues) {
        this.outputPropValues.currentValue = currentValue;
      }
      this.flagOutputDirty('currentValue');
    }
  },

  setup: function(context, graphModel) {
    // Handle style objects
    if (!context.propsInput) context.propsInput = {};
  },

  initialize: function() {
    // Initialize output value
    this._outputIsSelected = this.props.isSelected || false;
    if (!this.outputPropValues) this.outputPropValues = {};
    this.outputPropValues.currentValue = this._outputIsSelected;

    // Flag output as dirty so initial value is sent
    this.flagOutputDirty('currentValue');

    // Set up onChange handler
    this.props.onChange = (selected) => {
      this._outputIsSelected = selected;
      if (this.outputPropValues) {
        this.outputPropValues.currentValue = selected;
      }
      this.setInputValue('isSelected', selected);
      this.flagOutputDirty('currentValue');
      this.sendSignalOnOutput('onChange');
    };
  },

  methods: {
    setSelected: function(selected) {
      this.setInputValue('isSelected', selected);
    },
    toggle: function() {
      this.setInputValue('isSelected', !this.props.isSelected);
    },
    getSelected: function() {
      return this.props.isSelected || false;
    }
  }
});
